
import DefinedConstant from '../data/DefinedConstant'
import DefinedFunction from '../data/DefinedFunction'

export let util = {
    _aLogicFn: ['and', 'or'],
    _aFunction: Object.keys(DefinedFunction),
    _aMembers: DefinedConstant,
    _calcFn: DefinedFunction,

    REGEX: {
        member: /^([^,:;'=\[\]]+)$/,
        memberWithBracket: /^\${[^,:;'=\[\]]+}/,
        endWithIf: /.*if$/i
    },

    errMsg: {
        FORMULA_VARIABLE_FORMAT_ERR: 'Invalid variable format',
        //"a * + b", "*2", log(2,3), 1 * a, if(,,)
        FORMULA_FORMAT_ERR: 'Invalid formula format.',
        //member should be surrounded with "[]", else it's a constant number, so "a1000" is wrong, it should be "1000" or "[a1000]" 
        FORMULA_CONSTANT_ERR: 'Invalid constant number, constant number can only be digit.',
        //"[a100" or "a100]"
        FORMULA_MEMBER_ERR: 'Invalid member format, member should be surrounded with [].',
        //"[[a100]" or "a100]]"
        FORMULA_VARIABLE_ERR: 'Invalid variable format, variable should be surrounded with [\'\'].',
        //"(a + b", "(a + b))" 
        FORMULA_UNMATCH_BRAC: 'Unmatched () in formula.',
        //Invalidate character
        FORMULA_INVALIDATE_CHAR: 'Invalidate character {0} in formula.',
        //"[a] / 0", "1000 / 0.0"
        FORMULA_DIVIDE_ZERO: 'Cannot divide by zero.',
        //"", "()" 
        FORMULA_NOT_NULL: 'Formula cannot be empty.',
        //
        FORMULA_IF_FORMAT_ERR: 'Invalid if-else format.',
        // 
        FORMULA_FUNCTION_FORMAT_ERR: 'Invalid function format.',
        // 
        FORMULA_FUNCTION_NOT_EXIST: 'Function {0} does not exist.',
        //"if([error]+100, 0 ,0)"
        FORMULA_CONDITION_BOOL: 'Evaluation of if condition only can be boolean calculation.',
        //"if([a]>0, [error]>0, 0)"
        FORMULA_EXPRESSION_NOT_BOOL: 'Expression evaluation can NOT be logical operations.',
        //"([error]>0) + 2"
        FORMULA_ARITHMETIC_BOOL: 'Logical operations is not allowed in mathematical operations(+,-,*,/).',
        //"[a] or [a] > 1"
        FORMULA_BOOLEAN_VALUE: 'Value is not allowed in boolen calculation(and, or).',
        //final result cannot be a boolean calculation
        FORMULA_RESULT_BOOL: 'Formula computed result can NOT be boolean calculation.',
        //all clear :)
        FORMULA_VALID: 'Valid Formula.',
        //
        FORMULA_MEMBER_NOT_EXIST: 'Member {0} does not exist.',
        //"log(4) log(4)"
        FORMULA_OP_MISS: 'Missing operator.'
    },

    /**
     * [aaa] --> aaa
     * 
     * @param {String} sMember
     */
    removeMemberBrackets: function (sMember) {
        if (sMember.indexOf('[') !== -1 && sMember.indexOf(']') !== -1) {
            sMember = sMember.trim();
            if (sMember[0] === "[") {
                sMember = sMember.substring(1);
            }
            if (sMember[sMember.length - 1] === "]") {
                sMember = sMember.substring(0, sMember.length - 1);
            }
        }
        return sMember;
    },

    deepClone: function (target) {
        // 定义一个变量
        let result;
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
            // 如果是一个数组的话
            if (Array.isArray(target)) {
                result = []; // 将result赋值为一个数组，并且执行遍历
                for (let i in target) {
                    result.push(this.deepClone(target[i]))
                }
            } else if (target === null) {
                result = null;
            } else if (target.constructor === RegExp) {
                result = target;
            } else {
                result = {};
                for (let i in target) {
                    result[i] = this.deepClone(target[i]);
                }
            }
        } else {
            result = target;
        }
        return result;
    },
    TreeFilter(tree, ids, parent) {
        let _tree = JSON.parse(JSON.stringify(tree))
        if (ids.length == 0) {
            return _tree
        }
        let selectedNodes = []
        let nodes = _tree.filter((item) => {
            if (!item.children || item.children.length == 0) {
                item.checked = false
                item.selected = false
                if (ids.indexOf(item.name) > -1) {
                    if (parent) parent.expand = true
                    if (ids.length > 1) {
                        item.checked = true
                    } else {
                        item.selected = true
                    }
                    selectedNodes.push(item)
                }
                return true
            } else if (item.children && item.children.length > 0) {
                let _ret = this.TreeFilter(item.children, ids, item)
                item.children = _ret.nodes
                selectedNodes = selectedNodes.concat(_ret.selectedNodes)
                let ret = item.children.length > 0
                if (ret && parent) parent.expand = true
                return ret
            } else {
                return false
            }
        })
        return { 'nodes': nodes, 'selectedNodes': selectedNodes }
    }
}
